import { render, staticRenderFns } from "./ReportRatioQuarter.vue?vue&type=template&id=d2f0f42a&scoped=true&"
import script from "./ReportRatioQuarter.vue?vue&type=script&lang=js&"
export * from "./ReportRatioQuarter.vue?vue&type=script&lang=js&"
import style0 from "./ReportRatioQuarter.vue?vue&type=style&index=0&id=d2f0f42a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f0f42a",
  null
  
)

export default component.exports